import { useContext } from 'react'

import { FeatureFlagContext } from 'components'
import findFeatureFlag from 'utils/findFeatureFlag'

const useFeatureFlagEnabled = (flag: string): boolean => {
  const features = useContext(FeatureFlagContext)
  return findFeatureFlag(features, flag)?.setting === 'ENABLED'
}

export default useFeatureFlagEnabled
